<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Plan your Finances Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newPlanPillar()">New</a>
					<a href="#" @click="savePillar()" v-if="pillar">Save</a>
					<a href="#" @click="deleteSelected()" v-if="pillar">Delete</a>
					<a href="#" @click="onLoad()" v-if="pillar">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>

		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="doDeleteSelected()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal>
		<div class="row">
			<div class="col-md-3 mb-4" v-if="planpillars">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<small>{{planpillars.length}}Plan Pillars</small>
				<div class="leftSide">
					<b-table striped hover :filter="search" :items="planpillars" :fields="[{key: 'name', label: 'Pillar'}, 'enabled', {key:'priority', label: 'P'}]" selectable select-mode="single" @row-clicked="selectPillar"></b-table>
				</div>
			</div>
			<div class="col-md-9" v-if="pillar">
				<div class="m-5 mt-0">
					<h2>{{pillar.name}}</h2>
					<div class="mb-2"><small>ID: {{pillar.id}}</small></div>
					<div class="row">
						<div class="col-md-4">
							Name: <b-form-input class="mb-2" v-model="pillar.name"></b-form-input>
						</div> 
						<div class="col-md-1">
							Priority: <b-form-input class="mb-2" v-model="pillar.priority"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-5">
							Title: <b-form-input class="mb-2" v-model="pillar.title"></b-form-input>
						</div>
						<div class="col-md-4">
							Pillar CMS: <b-form-input class="mb-2" v-model="pillar.cmsPage"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							Description: <b-form-textarea rows="5" class="mb-2" v-model="pillar.description"></b-form-textarea>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Thumbnail (or calculator specific): <b-form-input class="mb-2" v-model="pillar.thumbnail"></b-form-input>
						</div>
						<div class="col-md-4">
							Pillar background img: <b-form-input class="mb-2" v-model="pillar.imgPath"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Learn more CTA: <b-form-input class="mb-2" v-model="pillar.cta"></b-form-input>
						</div>
					</div>
					<div class="pt-4">
						<div class="row pb-4">
							<div class="col-md-4"><p>Steps:</p></div>
							<div class="col-md-4">
								<b-button @click="addStep" variant="success">Add Step</b-button>
							</div>
						</div>
						<div v-for="step in pillar.steps" :key="step.id" >
							<div class="row step-card" >
								<p>Pillar step (like move): <small>{{step.id}}</small></p>
								<div class="row">
									<div class="col-md-6">
										Title: <b-form-input class="mb-2" v-model="step.title"></b-form-input>
									</div>
									<div class="col-md-1">
										Priority: <b-form-input class="mb-2" v-model="step.wellbeingRank"></b-form-input>
									</div>
								</div>
								<div class="col-md-12">
									Description: <b-form-textarea rows="5" class="mb-2" v-model="step.description"></b-form-textarea>
								</div>
								<div class="col-md-4">
									Background img: <b-form-input class="mb-2" v-model="step.backgroundImage"></b-form-input>
								</div>
								<div v-for="action in step.actions" :key="action.id" >
									<AppActionCard
										:action="action"
										@onDeleteAction="removeStepAction(step, action)" 
									/> 
								</div>
								<div class="row">
									<div class="col-md-4">
										<b-button @click="addStepAction(step)" variant="success">Add Action Button</b-button>
									</div>
									<div class="d-flex justify-content-end">
										<b-button @click="removeStep(step)" variant="danger">Delete step</b-button>
									</div>
								</div> 
							</div>
						</div>
					</div> 
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import AppActionCard from "./Widgets/AppActionCard";
export default {
  name: 'FinancialPlans',
  components: {
	AppActionCard
  },
  data() {
	return{
		planpillars: null,
		pillar: null,
		message: null,
		error: null,
		search: ""
	}
  },
  methods: {
	getPillars: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/FinancialPlan/Pillars")
			.then((result) => {
				this.planpillars = result.data;
				if (autoSelect) {
					if (this.planpillars.length > 0) {
						this.selectPillar(this.planpillars[0]);
					}
				}
			}
		)
	},
	selectPillar: function(p) {
		this.pillar = p;
	},
	savePillar: function(){
		if (this.pillar.id == null) {
			this.$http.post(this.$config.ApiUri + "/FinancialPlan/Pillars", this.pillar)
				.then((result) => {
					this.pillar = result.data;
					this.getPillars(false);
					this.showMessage("Pillar created OK!");
				}
			).catch(() => { this.showError(); });
		}
		else {
			this.$http.put(this.$config.ApiUri + "/FinancialPlan/Pillars/" + this.pillar.id, this.pillar)
				.then((result) => {
					this.pillar = result.data;
					this.getPillars(false);
					this.showMessage("Pillar saved OK!");
				}
			).catch(() => { this.showError(); });
		}
	},
	addStep: function() {
		this.pillar.steps.push({
			title:"",
			description: "",
			backgroundImage: "",
			actions: []
		});
	},
	addStepAction: function(step) {
		step.actions.push({
			cta: "",
			appScreen: "",
			cmsPage: "",
			externalURL: ""
		});
	},
	removeStep: function(step) {
		var i = this.pillar.steps.indexOf(step);
		this.pillar.steps.splice(i, 1);
	},
	removeStepAction: function(step, action) {
		var i = step.actions.indexOf(action);
		step.actions.splice(i, 1);
	},
	deleteSelected() {
		this.$bvModal.show('modSure');
	},
	doDeleteSelected() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/FinancialPlan/Pillars/" + this.pillar.id)
			.then(() => {
				this.pillar = null;
				this.getPillars(true);
				this.showMessage("Pillar deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that Pillar cannot be deleted. (" + error + ")"); });
	},
	newPlanPillar() {
		this.pillar = { 
			"name": "",
			"title": "",
			"description": "",
			"cta": "",
			"priority": "",
			"thumbnail": "",
			"imgPath": "",
			"cmsPage": "",
			"steps": []
		};
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getPillars(true);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.filters
{
	margin-bottom: 10px;
	width: 100%;
}

.filters .btn-group
{
	width: 100%;
}

.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.step-card {
	padding: 20px;
	margin-bottom: 10px;
	background-color:pink;
}

</style>